import type { ScenarioPreset } from '@/types';

export const scenarioPresets: ScenarioPreset[] = [
  {
    id: 'malware',
    name: 'scenarios.malware',
    description: 'Simulates blocking a known malware distribution site',
    icon: 'Bug',
    config: {
      blockedUrl: 'https://malware-distribution.example.com/payload.exe',
      category: 'malware',
      errorCode: 'FG-1005',
      blockType: 'intrusion-prevention',
      technicalDetails: {
        policyId: 'malware-block-001',
        firewallSerial: 'FGT60FTK21012345',
        threatId: 'W32/Malware.Generic',
        webFilterProfile: 'strict-security',
        securityProfile: 'antivirus-strict',
        sslInspection: 'enabled',
        actionTaken: 'blocked',
        sourceIp: '192.168.1.100',
        destinationIp: '185.220.101.42',
        destinationPort: '443',
        protocol: 'HTTPS',
        userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
        sessionId: 'sess_' + Math.random().toString(36).substr(2, 9),
        referrer: 'https://search-engine.example.com',
      },
    },
  },
  {
    id: 'phishing',
    name: 'scenarios.phishing',
    description: 'Simulates blocking a phishing attempt targeting credentials',
    icon: 'Fish',
    config: {
      blockedUrl: 'https://secure-bank-verify.example.com/login',
      category: 'phishing',
      errorCode: 'FG-1006',
      blockType: 'web-filter',
      technicalDetails: {
        policyId: 'phishing-block-002',
        firewallSerial: 'FGT60FTK21012345',
        threatId: 'PHISH/Bank.Credential.Theft',
        webFilterProfile: 'corporate-webfilter',
        securityProfile: 'webfilter-strict',
        sslInspection: 'enabled',
        actionTaken: 'blocked',
        sourceIp: '10.0.1.50',
        destinationIp: '203.0.113.88',
        destinationPort: '443',
        protocol: 'HTTPS',
        userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36',
        sessionId: 'sess_' + Math.random().toString(36).substr(2, 9),
        referrer: 'https://email-link.example.com/click',
      },
    },
  },
  {
    id: 'adult-content',
    name: 'scenarios.adultContent',
    description: 'Simulates blocking adult content in corporate environment',
    icon: 'AlertTriangle',
    config: {
      blockedUrl: 'https://adult-website.example.com/content',
      category: 'adult-content',
      errorCode: 'FG-1002',
      blockType: 'web-filter',
      technicalDetails: {
        policyId: 'aup-violation-003',
        firewallSerial: 'FGT60FTK21012345',
        threatId: 'N/A',
        webFilterProfile: 'corporate-aup',
        securityProfile: 'webfilter-standard',
        sslInspection: 'enabled',
        actionTaken: 'blocked',
        sourceIp: '192.168.10.25',
        destinationIp: '104.16.85.20',
        destinationPort: '443',
        protocol: 'HTTPS',
        userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/120.0.0.0',
        sessionId: 'sess_' + Math.random().toString(36).substr(2, 9),
        referrer: '',
      },
    },
  },
  {
    id: 'gaming',
    name: 'scenarios.gaming',
    description: 'Simulates blocking gaming sites in school environment',
    icon: 'Gamepad2',
    config: {
      blockedUrl: 'https://online-games.example.com/play',
      category: 'games',
      errorCode: 'FG-1004',
      blockType: 'web-filter',
      firewallMode: 'school',
      organization: 'Springfield High School',
      technicalDetails: {
        policyId: 'school-policy-games',
        firewallSerial: 'FGT100FTK21067890',
        threatId: 'N/A',
        webFilterProfile: 'education-k12',
        securityProfile: 'student-webfilter',
        sslInspection: 'enabled',
        actionTaken: 'blocked',
        sourceIp: '10.20.30.45',
        destinationIp: '151.101.1.140',
        destinationPort: '443',
        protocol: 'HTTPS',
        userAgent: 'Mozilla/5.0 (iPad; CPU OS 16_0 like Mac OS X) AppleWebKit/605.1.15',
        sessionId: 'sess_' + Math.random().toString(36).substr(2, 9),
        referrer: '',
      },
    },
  },
  {
    id: 'geo-block',
    name: 'scenarios.geoBlock',
    description: 'Simulates geo-blocking access from restricted regions',
    icon: 'Globe',
    config: {
      blockedUrl: 'https://streaming-service.example.com/watch',
      category: 'streaming',
      errorCode: 'FG-1003',
      blockType: 'web-filter',
      firewallMode: 'isp',
      organization: 'GlobalNet ISP',
      technicalDetails: {
        policyId: 'geo-restriction-004',
        firewallSerial: 'FGT3000FTK21099999',
        threatId: 'GEO-RESTRICTED',
        webFilterProfile: 'isp-compliance',
        securityProfile: 'geo-filtering',
        sslInspection: 'disabled',
        actionTaken: 'blocked',
        sourceIp: '203.0.113.50',
        destinationIp: '198.51.100.100',
        destinationPort: '443',
        protocol: 'HTTPS',
        userAgent: 'Mozilla/5.0 (Smart-TV; Linux; Tizen 6.0) AppleWebKit/537.36',
        sessionId: 'sess_' + Math.random().toString(36).substr(2, 9),
        referrer: '',
      },
    },
  },
  {
    id: 'social-media',
    name: 'scenarios.socialMedia',
    description: 'Simulates blocking social media during work hours',
    icon: 'Users',
    config: {
      blockedUrl: 'https://social-network.example.com/feed',
      category: 'social-media',
      errorCode: 'FG-1004',
      blockType: 'application-control',
      technicalDetails: {
        policyId: 'productivity-policy-005',
        firewallSerial: 'FGT200FTK21054321',
        threatId: 'N/A',
        webFilterProfile: 'corporate-productivity',
        securityProfile: 'app-control-strict',
        sslInspection: 'enabled',
        actionTaken: 'blocked',
        sourceIp: '172.16.5.30',
        destinationIp: '157.240.0.35',
        destinationPort: '443',
        protocol: 'HTTPS',
        userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Edge/120.0.0.0',
        sessionId: 'sess_' + Math.random().toString(36).substr(2, 9),
        referrer: '',
      },
    },
  },
  {
    id: 'streaming',
    name: 'scenarios.streaming',
    description: 'Simulates blocking video streaming to save bandwidth',
    icon: 'Video',
    config: {
      blockedUrl: 'https://video-streaming.example.com/movie',
      category: 'streaming',
      errorCode: 'FG-1004',
      blockType: 'application-control',
      technicalDetails: {
        policyId: 'bandwidth-policy-006',
        firewallSerial: 'FGT500FTK21098765',
        threatId: 'N/A',
        webFilterProfile: 'bandwidth-control',
        securityProfile: 'streaming-block',
        sslInspection: 'enabled',
        actionTaken: 'blocked',
        sourceIp: '192.168.50.75',
        destinationIp: '208.117.236.100',
        destinationPort: '443',
        protocol: 'HTTPS',
        userAgent: 'Mozilla/5.0 (Smart-TV; Linux) AppleWebKit/537.36',
        sessionId: 'sess_' + Math.random().toString(36).substr(2, 9),
        referrer: '',
      },
    },
  },
];

export const getScenarioById = (id: string): ScenarioPreset | undefined => {
  return scenarioPresets.find(s => s.id === id);
};

export const generateRandomSessionId = (): string => {
  return 'sess_' + Math.random().toString(36).substr(2, 9).toUpperCase();
};

export const generateRandomThreatId = (category: string): string => {
  const prefixes: Record<string, string> = {
    malware: 'W32/',
    phishing: 'PHISH/',
    'adult-content': 'CAT/',
    games: 'APP/',
    'social-media': 'APP/',
    streaming: 'APP/',
  };
  const prefix = prefixes[category] || 'THREAT/';
  return prefix + Math.random().toString(36).substr(2, 6).toUpperCase();
};
